import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { ChevronLeft, Tick } from '@yy/one-icon'
import { useSelector } from '@/store'
import { changeLanguage } from '@/store/languageSlice'
import { LANGUAGE } from '@/constants'

import { List } from 'antd'
import styles from './index.module.less'

interface PropsType {
  setSubMenu?: (val: boolean) => void
  setLangOpen?: (val: boolean) => void
  closeAll: () => void
}

const Language: React.FC<PropsType> = (props) => {
  const { setSubMenu, setLangOpen, closeAll } = props
  const languageStore = useSelector((state) => state.language)
  const { i18n, t } = useTranslation()
  const dispatch = useDispatch()

  const handleBack = () => {
    setLangOpen(false)
    setSubMenu(true)
  }

  const lanageChange = (option) => {
    i18n.changeLanguage(option.lang).then(() => {
      dispatch(changeLanguage(option))
      closeAll()
    })
  }

  return (
    <div className={styles.container}>
      <List className={styles.list}>
        <List.Item key={'country-return'} onClick={handleBack}>
          <div className={styles.back}>
            <ChevronLeft className={styles.icon} />
            <span>{t('common.return')}</span>
          </div>
        </List.Item>
        {LANGUAGE.map((lang) => {
          return (
            <List.Item
              className={`${lang.languageType === languageStore.languageType ? styles.active : ''}`}
              key={lang.label}
              onClick={lanageChange.bind(null, lang)}
              data-id={`user-language-menu-${lang.label}`}
              id={`user-language-menu-${lang.label}`}
            >
              <span className={styles.text}>{lang.label}</span>
              {lang.languageType === languageStore.languageType && <Tick className={styles.tickIcon} />}
            </List.Item>
          )
        })}
      </List>
    </div>
  )
}

Language.displayName = 'Language'
export default Language
